"use client";

import React from "react"
import { Box } from "../../components/common/_atoms"
import OfferContentGallery from "./OfferContentGallery"
import OfferContentHeader from "./OfferContentHeader"
import OfferContentInfo from "./OfferContentInfo"

const OfferContent = ({ id, status, brand, model, version, type, state, bodyType, year, course, gearBox, params, equipment, enginePower, engineCapacity, description, images, dtModified, coordinator, youtube }) => {
  return (
    <Box>
      <OfferContentHeader id={id} status={status} type={type} brand={brand} model={model} version={version} />
      {images?.length > 0 && <OfferContentGallery id={id} brand={brand} model={model} images={images} youtube={youtube} />}
      <OfferContentInfo type={type} equipment={equipment} state={state} bodyType={bodyType} year={year} course={course} gearBox={gearBox} params={params} engineCapacity={engineCapacity} enginePower={enginePower} description={description} dtModified={dtModified} coordinator={coordinator} />
    </Box>
  )
}

export default OfferContent
